import { Navigate } from 'react-router-dom'
import {
  AssignmentLateOutlined,
  EventNoteOutlined,
  FireTruckOutlined,
  HomeOutlined,
  InsightsOutlined,
  LocalShippingOutlined,
  ScaleOutlined,
  SettingsOutlined,
  SummarizeOutlined,
  SupportAgentOutlined,
  BusAlert,
} from '@mui/icons-material'
import {
  AutoAwesomeOutlined,
  HubOutlined,
  StorefrontOutlined,
  AssignmentReturnOutlined,
  ReportProblemOutlined,
  AccountBalanceWalletOutlined,
  LocationSearchingOutlined,
  CalculateOutlined,
  RuleOutlined,
  RequestQuoteOutlined,
  DownloadOutlined,
  BadgeOutlined,
  DashboardOutlined,
  LeaderboardOutlined,
  CampaignOutlined,
  NotificationsActiveOutlined,
  SpeedOutlined,
  WorkspacePremiumOutlined,
  RocketLaunchOutlined,
} from '@mui/icons-material'
import AllAppointments from '../app/components/appointments/AllAppointments'
import MissedRepeat from '../app/components/appointments/MissedRepeat'
import NeedsAction from '../app/components/appointments/NeedsAction'
import ReportsAnalytics from '../app/components/appointments/ReportsAnalytics'
import AppointmentsBulkUpload from '../app/components/appointments/BulkUpload'
import PtlToday from '../app/components/ptl-visibility/PtlToday'
import PtlNonAbdToday from '../app/components/ptl-visibility/NonAbdToday'
import PtlOverdueAppointments from '../app/components/ptl-visibility/OverdueAppointments'
import PtlEddBreaches from '../app/components/ptl-visibility/EddBreaches'
import PtlPodAnalytics from '../app/components/ptl-visibility/PodAnalytics'
import PtlPerformanceOverview from '../app/components/ptl-visibility/PerformanceOverview'
import PtlLegacyPathRedirect from '../app/components/ptl-visibility/LegacyPathRedirect'
import TrackingConfig from '../app/components/tracking/TrackingConfig'
import ProshipPilot from '../app/components/ProshipPilot'
import PaceAboutPage from '../app/components/pace-about/PaceAboutPage'
import Dashboard from '../app/components/dashboard/Dashboard'
import HomePage from '../app/components/home/HomePage'
import Performance from '../app/components/dashboard/performance/Performance'
import ControlTower from '../app/components/ct'
import BrandHealth from '../app/components/health/BrandHealth'
// import CourierHealth from '../app/components/health/CourierHealth' // hidden from CT
import ListOrder2 from '../app/components/orders/list2'
// DIY — Forward Shipments v2 hidden on prod. Uncomment with the menu entry below when DIY goes live.
// import ForwardShipmentsV2 from '../app/components/orders/v2/ForwardShipmentsV2'
import CreateB2COrder from '../app/components/orders/CreateV2/CreateB2COrder'
import CreateB2COrderRVP from '../app/components/orders/CreateRVPV2/CreateB2COrder'
import CloneOrderStepper from '../app/components/orders/CloneV2/CloneOrderStepper'
import Bulkordercreate from '../app/components/orders/create/bulkordercreate'
import BulkOrderUpload from '../app/components/orders/create/BulkOrderUpload'
import CreateShipment from '../app/components/orders/CreateShipment'
import LabelsInvoices from '../app/components/orders/LabelsInvoices'
import BulkDownloadLabelsB2C from '../app/components/orders/download/BulkDownloadLabelsB2C'
import BulkInvoiceDownload from '../app/components/orders/download/BulkInvoiceDownload'
import StuckOrders from '../app/components/orders/list2/StuckOrders'
import Manifest from '../app/components/orders/list2/Manifest'
import BulkTracking from '../app/components/orders/list2/BulkTracking'
import BulkMarkRtoRequested from '../app/components/orders/BulkMarkRtoRequested'
import ShipmentRateCalculatorPTL from '../app/components/shipment-calculator-ptl'
import CreatePTLShipment from '../app/components/B2BOrder/CreatePTLShipment'
import CreateMPSShipment from '../app/components/B2BOrder/CreateMPSShipment'
import CreatePickupRequest2 from '../app/components/PickupRequest'
import PtlPickupRequests from '../app/components/orders/list2/PickupRequest'
import UploadTracking from '../app/components/orders/list2/UploadTracking'
import AppointmentDeliveries from '../app/components/orders/list2/AppointmentDeliveries'
import BulkDownloadLabelsB2B from '../app/components/orders/download/BulkDownloadB2B'
import ReverseOrders from '../app/components/orders/list2/ReverseOrders'
import ReturnOrders from '../app/components/orders/returns'
import RvpWithQc from '../app/components/orders/rvp-qc'
import AllChannelOrders from '../app/components/orders/list2/ChannelOrders'
import NDRListing from '../app/components/ndr'
import WhatsAppNDR from '../app/components/ndr/WhatsAppNDR'
import NDRAutomation from '../app/components/ndr/NDRAutomation'
import CallRecordings from '../app/components/ndr/CallRecordings'
import WhatsAppConversations from '../app/components/ndr/WhatsAppConversations'
import NPRListing from '../app/components/npr'
import NPRCallRecordings from '../app/components/npr/CallRecordings'
import VasDashboard from '../app/components/vas/VasDashboard'
import ListWeightOrders from '../app/components/weight/list'
import WeightDisputesV2 from '../app/components/weight/disputes-v2'
import WeightFreezeV2 from '../app/components/weight/freeze-v2'
// import Serviceability from '../app/components/serviceability' // Check PIN Serviceability commented out
import DownloadServiceability from '../app/components/serviceability/DownloadServiceability'
import CheckServiceability from '../app/components/serviceability/CheckServiceability'
import Coverage from '../app/components/serviceability/Coverage'
import ShipmentCalculator from '../app/components/shipment-calculator'
import OrderCreationLatency from '../app/components/order-creation-latency'
import Rules from '../app/components/Merchant Rule/Rules'
import ZoneMapping from '../app/components/zone Mapping'
import AWBbasedMIS from '../app/components/orders/list2/AWBbasedMIS'
import SorterImage from '../app/components/orders/list2/SorterImage'
import BulkDownloadPOD from '../app/components/orders/download/BulkDownloadPOD'
import {BillingCodRemittance, BillingWalletRecharges, BillingPassbook} from '../app/components/billing'
import Credit from '../app/components/credit'
import MerchantInvoice from '../app/components/merchant Invoice/MerchantInvoice'
import Profile from '../app/components/profile'
import Setting from '../app/components/setting'
import Reports from '../app/components/reports'
import EscalationManagement from '../app/components/EscalationManagement'
import View from '../app/components/EscalationManagement/View'
import EscalationManagementV2 from '../app/components/EscalationManagementV2'
import EscalationV2ViewTicket from '../app/components/EscalationManagementV2/ViewTicket'
import CustomRule from '../app/components/CourierPriority/CustomRule'
import ReverseOrder from '../app/components/orders/create/ReverseOrder'
import PickupRequestDetails from '../app/components/orders/list2/PickupRequestDetails'
import OrderDetail from '../app/components/orders/detail'
import ListTracking from '../app/components/tracking/list'
import TrackingDetail from '../app/components/tracking/detail'
import PickupLocationTab from '../app/components/merchant-onboarding/locations/pickupLocation'
import MerchantUsers from '../app/components/merchant-onboarding/users'
import MerchantPreview from '../app/components/merchant-onboarding/preview'
import CreateOrderStep2 from '../app/components/orders/create/step2'
import PreviewOrder from '../app/components/orders/create/preview'
import { Package } from '../app/components/package'
import WeightDiscrepancyUpload from '../app/components/weight/list/WeightDiscrepancy'
import MerchantDeliveryLocations from '../app/components/merchant-onboarding/locations/deliveryLocations'
import Notification from '../app/components/notification'
import PushNotificationList from '../app/common/PushNotification'
import Kyc from '../app/components/user/kyc'
import NotificationConfig from '../app/components/notification/NotificationConfig'
import ShopifyEddLocation from '../app/components/shopify-edd-location/ShopifyEddLocation'
import PrivacyPolicy from '../app/common/PrivacyPolicy'
import RefundPolicy from '../app/common/RefundPolicy'
import ChangePassword from '../app/components/profile/changePassword'
import RateCard from '../app/components/RateCard'
import ConfiguWebhook from '../app/components/webhook/ConfiguWebhook'
import ViewWebHook from '../app/components/webhook/ViewwebHook'
import CodOnHoldConfig from '../app/components/orders/list2/CodOnHoldConfig'
import EmailConfig from '../app/components/EmaiConfigs/EmailConfig'
import ConfigMain from '../app/components/CommunicationConfigs'
import UpdateB2COrder from '../app/components/orders/list2/UpdatePaymentMode'
import InvoiceLabelMergeDownload from '../app/components/orders/download/InvoiceLabelMergeDownload'
import AllClaims from '../app/components/claims/AllClaims'
import ClaimDetail from '../app/components/claims/ClaimDetail'
import ReleaseNotes from '../app/components/ReleaseNotes'
import ReleaseNoteDetail from '../app/components/ReleaseNotes/Detail'
// ProShip Direct v2 — additive route group, empty unless REACT_APP_DIRECT_PLAN is on.
import {directPlanRoutes} from '../app/components/directPlan/routes'
import {WEIGHT_V2_CONFIG} from './weightV2Visibility'
import {EMS_V2_ENABLED} from './emsV2Visibility'
// import MonthOnMonthAnalysis from "../app/components/dashboard/MonthOnMonthAnalysis";
/* import RateCard from '../app/components/RateCard' */

export const ROLES = {
  CT: 'CT',
  DASHBOARD: 'DASHBOARD',
  PERFORMANCE: 'PERFORMANCE',
  ORDERS: 'ORDERS',
  B2C_ACCESS: 'B2C_ACCESS',
  PTL_ACCESS: 'PTL_ACCESS',
  NDR: 'NDR',
  WEIGHT_DESC: 'WEIGHT_DESC',
  TOOLS: 'TOOLS',
  FINANCE: 'FINANCE',
  SETTINGS: 'SETTINGS',
  REPORTS: 'REPORTS',
}

const PROPILOT_ALLOWED_DOMAINS = (process.env.REACT_APP_PROPILOT_ALLOWED_DOMAINS || 'prozo.com')
  .split(',')
  .map((d) => d.trim().toLowerCase())
  .filter(Boolean)

export const ROLE_COMBINATIONS = {
  B2C_ORDERS: [ROLES.ORDERS, ROLES.B2C_ACCESS],
  PTL_ORDERS: [ROLES.PTL_ACCESS, ROLES.ORDERS],
  ALL_ORDERS: [ROLES.PTL_ACCESS, ROLES.B2C_ACCESS, ROLES.ORDERS],
  CONTROL_TOWER: [ROLES.CT],
  DASHBOARD_ACCESS: [ROLES.DASHBOARD],
  PERFORMANCE_ACCESS: [ROLES.PERFORMANCE],
  NDR_ACCESS: [ROLES.NDR],
  WEIGHT_DISCREPANCY: [ROLES.WEIGHT_DESC],
  CLAIMS_ACCESS: [ROLES.B2C_ACCESS, ROLES.PTL_ACCESS, ROLES.ORDERS, ROLES.DASHBOARD, ROLES.NDR, ROLES.WEIGHT_DESC],
  TOOLS_ACCESS: [ROLES.TOOLS],
  FINANCE_ACCESS: [ROLES.FINANCE],
  SETTINGS_ACCESS: [ROLES.SETTINGS],
  REPORTS_ACCESS: [ROLES.REPORTS],
}

export const routesConfig = [
  // ══════════════════════════════════════════════════════════════
  // ZONE: GENERAL — visible to both D2C and PTL verticals
  // ══════════════════════════════════════════════════════════════
  {
    pathname: '/home',
    roles: ROLE_COMBINATIONS.DASHBOARD_ACCESS,
    icon: <HomeOutlined />,
    label: 'Home',
    id: 'menu-home',
    component: <HomePage />,
    displayInSidebar: true,
    group: 'GENERAL',
    zone: 'GENERAL',
    vertical: 'BOTH',
  },
  {
    pathname: '/dashboard',
    roles: ROLE_COMBINATIONS.DASHBOARD_ACCESS,
    icon: <DashboardOutlined />,
    label: 'Common Dashboard',
    id: 'menu-dashboard',
    // Hidden from the sidebar: the same tabs now live under the D2C & PTL dashboards.
    // Kept as routes (not commented out) so the /dashboard default landing, the HomePage
    // quick link, and the WhatsApp Shipment Status page keep working.
    displayInSidebar: false,
    group: 'GENERAL',
    zone: 'GENERAL',
    vertical: 'BOTH',
    menuItems: [
      {pathname: '/dashboard', label: 'Overview', component: <Dashboard />},
      {pathname: '/dashboard/shipments', label: 'Shipments', component: <Dashboard />},
      {pathname: '/dashboard/shipment-alerts', label: 'Shipment Alerts', component: <Dashboard />},
      {pathname: '/dashboard/lost', label: 'Lost & Damaged', component: <Dashboard />},
      {pathname: '/dashboard/whatsapp-status', label: 'WhatsApp Shipment Status', component: <WhatsAppNDR />},
    ],
  },
  {
    pathname: '/d2c-dashboard',
    roles: ROLE_COMBINATIONS.B2C_ORDERS,
    icon: <DashboardOutlined />,
    label: 'D2C Dashboard',
    id: 'menu-d2c-dashboard',
    displayInSidebar: true,
    group: 'D2C_FREIGHT',
    zone: 'D2C_FREIGHT',
    vertical: 'D2C',
    menuItems: [
      {pathname: '/d2c-dashboard', label: 'Overview', component: <Dashboard />},
      {pathname: '/d2c-dashboard/shipments', label: 'Shipments', component: <Dashboard />},
      {pathname: '/d2c-dashboard/shipment-alerts', label: 'Shipment Alerts', component: <Dashboard />},
      {pathname: '/d2c-dashboard/lost', label: 'Lost & Damaged', component: <Dashboard />},
      {pathname: '/d2c-dashboard/whatsapp-status', label: 'WhatsApp Shipment Status', component: <WhatsAppNDR />},
    ],
  },
  {
    pathname: '/analytics',
    roles: ROLE_COMBINATIONS.PERFORMANCE_ACCESS,
    icon: <HubOutlined />,
    label: 'Control Tower',
    id: 'menu-control-tower',
    displayInSidebar: true,
    group: 'GENERAL',
    zone: 'GENERAL',
    vertical: 'BOTH',
    menuItems: [
      {pathname: '/analytics', label: 'Overall Summary', component: <Performance />},
      {pathname: '/analytics/brand-health', label: 'Brand Health', component: <BrandHealth />},
      // {pathname: '/analytics/courier-health', label: 'Courier Health', component: <CourierHealth />}, // hidden from CT
      {pathname: '/analytics/forward', label: 'Forward Deliveries', component: <Performance />},
      {pathname: '/analytics/pickup', label: 'Pickup Performance', component: <Performance />},
      {pathname: '/analytics/rto', label: 'RTO Analysis', component: <Performance />},
      {pathname: '/analytics/ndr', label: 'NDR Analysis', component: <Performance />},
      {pathname: '/analytics/lost', label: 'Lost & Damaged', component: <Performance />},
      {pathname: '/analytics/rvp', label: 'RVP', component: <Performance />},
      {pathname: '/analytics/stuck', label: 'Stuck Shipments', component: <Performance />},
      {pathname: '/analytics/fake', label: 'Fake Deliveries', component: <Performance />},
    ],
  },
  // Keep old /control-tower route for backward compatibility (not in sidebar)
  {
    pathname: '/control-tower',
    roles: ROLE_COMBINATIONS.CONTROL_TOWER,
    component: <ControlTower />,
  },
  // ── AI TOOLS group ──
  {
    pathname: '/proship-pilot',
    allowedEmailDomains: PROPILOT_ALLOWED_DOMAINS,
    icon: <AutoAwesomeOutlined />,
    label: 'ProPilot AI',
    component: <ProshipPilot />,
    displayInSidebar: true,
    group: 'AI_TOOLS',
    zone: 'AI_TOOLS',
    vertical: 'BOTH',
  },

  // ══════════════════════════════════════════════════════════════
  // ZONE: D2C_FREIGHT — D2C / B2C shipping vertical
  // ══════════════════════════════════════════════════════════════
  {
    pathname: '/orders',
    roles: ROLE_COMBINATIONS.B2C_ORDERS,
    icon: <LocalShippingOutlined />,
    label: 'D2C Shipments',
    id: 'menu-shipment',
    displayInSidebar: true,
    group: 'D2C_FREIGHT',
    zone: 'D2C_FREIGHT',
    vertical: 'D2C',
    menuItems: [
      {
        pathname: '/orders',
        label: 'Forward Shipments',
        component: <ListOrder2 shipmentType='B2C' />,
      },
      /* DIY — Forward Shipments v2 hidden on prod (part of the ProShip Direct revamp,
         not live yet). Uncomment when DIY goes live — see components/orders/v2/ForwardShipmentsV2.js.
      {
        // The revamp, alongside the page above rather than replacing it — see
        // components/orders/v2/ForwardShipmentsV2.js. Both stay routable until v2 covers
        // everything the original does.
        pathname: '/shipments-v2',
        label: 'Forward Shipments v2',
        component: <ForwardShipmentsV2 />,
      },
      */
      {
        pathname: '/pending-pickups',
        label: 'Manifest & Pickups',
        // Home of grouped bulk-manifest generation (leadership-confirmed placement:
        // visible in the sidebar, directly below Forward Shipments).
        // /labels-invoices?tab=manifest keeps the original single-group flow.
        component: <Manifest grouped />,
      },
      {
        pathname: '/create-shipment',
        label: 'Create Shipment',
        component: <CreateShipment />,
      },
      // The three flows above used to be separate sidebar entries. They are now tabs of
      // /create-shipment, but the original paths stay routable (hidden from the sidebar)
      // so existing links — e.g. the "Create new order" button on the order preview —
      // keep resolving to the same components.
      {
        pathname: '/create-order',
        label: 'Create Forward Shipment',
        hideInSidebar: true,
        component: <CreateB2COrder />,
      },
      {
        pathname: '/create-order-rvp',
        label: 'Create Reverse Shipment',
        hideInSidebar: true,
        component: <CreateB2COrderRVP />,
      },
      {
        pathname: '/bulk-order-create',
        label: 'Create Bulk Shipments',
        hideInSidebar: true,
        component: <Bulkordercreate shipmentType='B2C' />,
      },
      {
        pathname: '/bulk-order-upload',
        label: 'Create Bulk Orders',
        component: <BulkOrderUpload />,
      },
      {
        pathname: '/labels-invoices',
        label: 'Labels, Invoices & Manifests',
        component: <LabelsInvoices />,
      },
      // Now tabs of /labels-invoices; the original paths stay routable but hidden so
      // existing bookmarks keep working.
      {
        pathname: '/download-labels-b2c',
        label: 'D2C Labels',
        hideInSidebar: true,
        component: <BulkDownloadLabelsB2C />,
      },
      {
        pathname: '/download-invoice',
        label: 'D2C Invoices',
        hideInSidebar: true,
        component: <BulkInvoiceDownload />,
      },
      {
        pathname: '/download-invoice-label-merge-b2c',
        label: 'Bulk Download Label and Invoice (Merged File)',
        hideInSidebar: true,
        component: <InvoiceLabelMergeDownload type='B2C' />,
      },
      {
        pathname: '/stuck-orders',
        label: 'Unprocessed Shipments',
        component: <StuckOrders />,
      },
      {
        pathname: '/bulk-tracking',
        label: 'Bulk Tracking',
        component: <BulkTracking />,
      },
      {
        pathname: '/update-payment-mode',
        label: 'Update Payment Mode',
        badge: 'NEW',
        component: <UpdateB2COrder />,
        enableForConfig: 'codToPrepadEnabled',
      },
    ],
  },
  {
    pathname: '/channel-orders',
    roles: ROLE_COMBINATIONS.B2C_ORDERS,
    icon: <StorefrontOutlined />,
    label: 'Channel Orders',
    id: 'menu-channel-orders',
    component: <AllChannelOrders />,
    displayInSidebar: true,
    group: 'D2C_FREIGHT',
    zone: 'D2C_FREIGHT',
    vertical: 'D2C',
    enableForConfig: 'channelOrdersVisibleMerchantPanel',
  },
  {
    pathname: '/returns',
    roles: ROLE_COMBINATIONS.B2C_ORDERS,
    icon: <AssignmentReturnOutlined />,
    label: 'Returns & RVP',
    id: 'menu-rvp-shipment',
    displayInSidebar: true,
    group: 'D2C_FREIGHT',
    zone: 'D2C_FREIGHT',
    vertical: 'D2C',
    enableForConfig: 'returnsVisibleMerchantPanel',
    menuItems: [
      { pathname: '/reverse-orders', label: 'Reverse Shipments', component: <ReverseOrders /> },
      { pathname: '/return-orders', label: 'Return Order Requests', component: <ReturnOrders /> },
      { pathname: '/rvp/qc', label: 'RVP QC Parameters', component: <RvpWithQc />, enableForConfig: 'showRvpQcToMerchant' },
    ],
  },
  {
    pathname: '/ndr',
    roles: ROLE_COMBINATIONS.NDR_ACCESS,
    icon: <ReportProblemOutlined />,
    label: 'NDR Management',
    id: 'menu-ndr',
    displayInSidebar: true,
    group: 'D2C_FREIGHT',
    zone: 'D2C_FREIGHT',
    vertical: 'D2C',
    menuItems: [
      {pathname: '/ndr', label: 'NDR Dashboard', component: <NDRListing />},
      {pathname: '/ndr/call-recordings', label: 'Call Recordings', component: <CallRecordings />},
      {pathname: '/ndr/whatsapp-conversations', label: 'WhatsApp Conversations', component: <WhatsAppConversations />},
      {pathname: '/ndr/automation', label: 'NDR Automation', component: <NDRAutomation />},
    ],
  },
  {
    pathname: '/vas-dashboard',
    roles: ROLE_COMBINATIONS.B2C_ORDERS,
    icon: <WorkspacePremiumOutlined />,
    label: 'Value-Added Services',
    id: 'menu-vas',
    displayInSidebar: true,
    group: 'D2C_FREIGHT',
    zone: 'D2C_FREIGHT',
    vertical: 'D2C',
    menuItems: [
      {pathname: '/vas-dashboard', label: 'Value-Added Services', component: <VasDashboard />},
    ],
  },
  {
    pathname: '/npr',
    roles: ROLE_COMBINATIONS.NDR_ACCESS,
    icon: <BusAlert />,
    label: 'NPR Management',
    id: 'menu-npr',
    displayInSidebar: true,
    group: 'D2C_FREIGHT',
    zone: 'D2C_FREIGHT',
    vertical: 'D2C',
    menuItems: [
      { pathname: '/npr', label: 'NPR Dashboard', component: <NPRListing /> },
      { pathname: '/npr/call-recordings', label: 'Call Recordings', component: <NPRCallRecordings /> },
    ],
  },
  {
    pathname: '/weight-discrepancy',
    roles: ROLE_COMBINATIONS.WEIGHT_DISCREPANCY,
    icon: <ScaleOutlined />,
    label: 'Weight Management',
    id: 'menu-weight',
    displayInSidebar: true,
    group: 'D2C_FREIGHT',
    zone: 'D2C_FREIGHT',
    vertical: 'D2C',
    menuItems: [
      {pathname: '/weight-discrepancy', label: 'Weight Disputes', component: <ListWeightOrders />},
      // In a production build, only for merchants in the Weight v2 programme — see weightV2Visibility.js.
      {pathname: '/weight-disputes-v2', label: 'Weight Discrepancy', component: <WeightDisputesV2 />, enableForConfig: WEIGHT_V2_CONFIG},
      // Weight Freeze, folded in from the top-level row it used to own. Both
      // rows gate on WEIGHT_DESC, so nothing about who can reach the module
      // changed; what changed is that a merchant now finds every weight screen
      // in one place. The row lands on the freeze dashboard rather than on the
      // module's bare path because that dashboard is the screen merchants come
      // here to use — the two entries below it are the rest of the module,
      // routable but reached from inside the page instead of from a row.
      //
      // These pathnames are mirrored in freeze-v2/sections.js's MODULES; keep
      // the two in step. The module's fourth sub-module, Package master, is a
      // child of Settings instead — see that entry further down.
      {pathname: '/weight-freeze-v2/initiate', label: 'Merchant Weight Freeze', component: <WeightFreezeV2 />, enableForConfig: WEIGHT_V2_CONFIG},
      // No sidebar row: the SoP is reached by the "Weight freeze SOP" button on
      // the freeze dashboard, and by RequestsSection's "Read the procedure". A
      // row of its own said "read me first" about a page nobody navigates to
      // twice, and cost the module a permanent line in the sidebar.
      {pathname: '/weight-freeze-v2', label: 'Overview and SOP', component: <WeightFreezeV2 />, hideInSidebar: true, enableForConfig: WEIGHT_V2_CONFIG},
      // No sidebar row: the DWS readings are to be asked for inside Weight
      // Freeze's own drawer instead. The ROUTE stays registered because three
      // live in-page links still name it — the mid-raise "Go to DWS data", a
      // review card's "Open DWS images", and SoP step 3 — and they have
      // nowhere else to go until that drawer collects the readings itself.
      // Delete this entry, and the module entry beside it, once it does.
      {pathname: '/weight-freeze-v2/dws', label: 'DWS data', component: <WeightFreezeV2 />, hideInSidebar: true, enableForConfig: WEIGHT_V2_CONFIG},
    ],
  },
  {
    pathname: '/claims',
    roles: ROLE_COMBINATIONS.CLAIMS_ACCESS,
    icon: <AssignmentLateOutlined />,
    label: 'Claims',
    id: 'menu-claims',
    component: <AllClaims />,
    displayInSidebar: true,
    group: 'D2C_FREIGHT',
    zone: 'D2C_FREIGHT',
    vertical: 'D2C',
  },
  {
    pathname: '/rate-calculator',
    roles: ROLE_COMBINATIONS.TOOLS_ACCESS,
    icon: <CalculateOutlined />,
    label: 'D2C Rate Calculator',
    component: <ShipmentCalculator />,
    displayInSidebar: true,
    group: 'D2C_FREIGHT',
    zone: 'D2C_FREIGHT',
    vertical: 'D2C',
  },
  {
    pathname: '/order-creation-latency',
    roles: ROLE_COMBINATIONS.TOOLS_ACCESS,
    icon: <SpeedOutlined />,
    label: 'Order Creation Latency',
    id: 'menu-order-creation-latency',
    component: <OrderCreationLatency />,
    displayInSidebar: true,
    group: 'D2C_FREIGHT',
    zone: 'D2C_FREIGHT',
    vertical: 'D2C',
  },
  {
    pathname: '/zone-mapping',
    roles: ROLE_COMBINATIONS.B2C_ORDERS,
    icon: <DownloadOutlined />,
    label: 'Downloads',
    id: 'menu-d2c-downloads',
    displayInSidebar: true,
    group: 'D2C_FREIGHT',
    zone: 'D2C_FREIGHT',
    vertical: 'D2C',
    menuItems: [
      { pathname: '/zone-mapping', label: 'Zone Mapping', component: <ZoneMapping freightType='B2C' /> },
      { pathname: '/download-pod', label: 'Proof of Delivery', component: <BulkDownloadPOD freightType='B2C' /> },
    ],
  },
  {
    pathname: '/merchant-rules',
    roles: ROLE_COMBINATIONS.B2C_ORDERS,
    icon: <RuleOutlined />,
    label: 'Shipping Rules',
    id: 'menu-d2c-shipping-rules',
    displayInSidebar: true,
    group: 'D2C_FREIGHT',
    zone: 'D2C_FREIGHT',
    vertical: 'D2C',
    enableForConfig: 'allocationVisibleMerchantPanel',
    component: <Rules freightType='B2C' />,
  },
  {
    // Automated Allocation → About PACE: explainer for Prozo's AI courier allocation (PACE).
    // Presentation only, no API calls. Deliberately not gated on allocationVisibleMerchantPanel
    // so merchants not yet on automated allocation can discover it.
    pathname: '/pace/about',
    roles: ROLE_COMBINATIONS.B2C_ORDERS,
    icon: <RocketLaunchOutlined />,
    label: 'Automated Allocation',
    id: 'menu-d2c-automated-allocation',
    displayInSidebar: true,
    group: 'D2C_FREIGHT',
    zone: 'D2C_FREIGHT',
    vertical: 'D2C',
    menuItems: [
      {pathname: '/pace/about', label: 'About PACE', component: <PaceAboutPage />},
    ],
  },

  // ══════════════════════════════════════════════════════════════
  // ZONE: PTL_FREIGHT — PTL / B2B shipping vertical
  // ══════════════════════════════════════════════════════════════
  {
    pathname: '/ptl-dashboard',
    roles: ROLE_COMBINATIONS.PTL_ORDERS,
    icon: <DashboardOutlined />,
    label: 'PTL Dashboard',
    displayInSidebar: true,
    group: 'PTL_FREIGHT',
    zone: 'PTL_FREIGHT',
    vertical: 'PTL',
    menuItems: [
      {pathname: '/ptl-dashboard/performance-overview', label: 'Performance Overview', component: <PtlPerformanceOverview />},
      {pathname: '/ptl-dashboard', label: 'Overview', component: <Dashboard />},
      {pathname: '/ptl-dashboard/ptl-shipments', label: 'Shipments', component: <Dashboard />},
      {pathname: '/ptl-dashboard/ptl-alerts', label: 'Shipment Alerts', component: <Dashboard />},
      {pathname: '/ptl-dashboard/ptl-lost', label: 'Lost & Damaged', component: <Dashboard />},
      {pathname: '/ptl-dashboard/whatsapp-status', label: 'WhatsApp Shipment Status', component: <WhatsAppNDR />},
    ],
  },
  {
    // PTL Delivery Health: merchant-scoped, read-only PTL views (docs/PTL_PLAN.md). Landing page = today's shipments.
    pathname: '/ptl-delivery-health',
    roles: ROLE_COMBINATIONS.PTL_ORDERS,
    icon: <InsightsOutlined />,
    label: 'PTL Delivery Health',
    id: 'menu-ptl-delivery-health',
    displayInSidebar: true,
    group: 'PTL_FREIGHT',
    zone: 'PTL_FREIGHT',
    vertical: 'PTL',
    menuItems: [
      {pathname: '/ptl-delivery-health', label: "Today's Shipments", component: <PtlToday />},
      {pathname: '/ptl-delivery-health/pod-analytics', label: 'PoD Analytics', component: <PtlPodAnalytics />},
    ],
  },
  // Pages moved out of PTL Delivery Health: their old URLs open the new place.
  {
    pathname: '/ptl-delivery-health/overdue-appointments',
    roles: ROLE_COMBINATIONS.PTL_ORDERS,
    component: <PtlLegacyPathRedirect to='/appointments/overdue' />,
  },
  {
    pathname: '/ptl-delivery-health/edd-breaches',
    roles: ROLE_COMBINATIONS.PTL_ORDERS,
    component: <PtlLegacyPathRedirect to='/nonabd-edd-breaches' />,
  },
  {
    pathname: '/ptl-delivery-health/performance-overview',
    roles: ROLE_COMBINATIONS.PTL_ORDERS,
    component: <PtlLegacyPathRedirect to='/ptl-dashboard/performance-overview' />,
  },
  {
    // Opened from the Non-ABD card on PTL Delivery Health; not a sidebar item.
    pathname: '/ptl-delivery-health/non-abd-today',
    roles: ROLE_COMBINATIONS.PTL_ORDERS,
    component: <PtlNonAbdToday />,
  },
  // Old URLs from before the rename (PTL Visibility → PTL Delivery Health) redirect to the new ones.
  {
    pathname: '/ptl-visibility',
    roles: ROLE_COMBINATIONS.PTL_ORDERS,
    component: <PtlLegacyPathRedirect />,
  },
  {
    pathname: '/ptl-visibility/non-abd-today',
    roles: ROLE_COMBINATIONS.PTL_ORDERS,
    component: <PtlLegacyPathRedirect />,
  },
  {
    pathname: '/ptl-visibility/overdue-appointments',
    roles: ROLE_COMBINATIONS.PTL_ORDERS,
    component: <PtlLegacyPathRedirect />,
  },
  {
    pathname: '/ptl-visibility/edd-breaches',
    roles: ROLE_COMBINATIONS.PTL_ORDERS,
    component: <PtlLegacyPathRedirect />,
  },
  {
    pathname: '/ptl-visibility/pod-analytics',
    roles: ROLE_COMBINATIONS.PTL_ORDERS,
    component: <PtlLegacyPathRedirect />,
  },
  {
    pathname: '/ptl-visibility/performance-overview',
    roles: ROLE_COMBINATIONS.PTL_ORDERS,
    component: <PtlLegacyPathRedirect />,
  },
  {
    pathname: '/ptl-all-shipments',
    roles: ROLE_COMBINATIONS.PTL_ORDERS,
    icon: <FireTruckOutlined />,
    label: 'All Shipments',
    id: 'menu-ptl-all-shipments',
    displayInSidebar: true,
    group: 'PTL_FREIGHT',
    zone: 'PTL_FREIGHT',
    vertical: 'PTL',
    menuItems: [
      {
        pathname: '/ptl-all-shipments',
        label: 'All Shipments',
        component: <ListOrder2 shipmentType='B2B' abdMode='all' />,
      },
      {
        pathname: '/create-b2b-orders',
        label: 'Create Shipment',
        component: <CreatePTLShipment />,
      },
      {
        pathname: '/create-mps-orders',
        label: 'Create MPS Shipment',
        component: <CreateMPSShipment />,
      },
      {
        pathname: '/upload-b2b-orders',
        label: 'Create Bulk Shipments',
        component: <Bulkordercreate shipmentType='B2B' />,
      },
      {
        pathname: '/create-pickup-request',
        label: 'Create Pickup Request',
        component: <CreatePickupRequest2 />,
      },
      {
        pathname: '/ptl-pickup-requests',
        label: 'Pickup Requests',
        component: <PtlPickupRequests />,
      },
      {
        pathname: '/b2b_tracking_upload',
        label: 'Upload For Tracking',
        component: <UploadTracking />,
      },
      {
        pathname: '/download-labels-b2b',
        label: 'Bulk Download Labels',
        component: <BulkDownloadLabelsB2B />,
      },
      {
        pathname: '/bulk-mark-rto',
        label: 'Bulk Mark RTO',
        component: <BulkMarkRtoRequested />,
      },
    ],
  },
  {
    // Non-ABD PTL Shipments — mirrors the ABD menu's pages but scoped to Non-ABD
    // (appointdeliveryRequired=false). Distinct pathnames so they don't collide with the
    // ABD routes; each appointment page runs in Non-ABD mode via abd={false}.
    pathname: '/b2b-orders',
    roles: ROLE_COMBINATIONS.PTL_ORDERS,
    icon: <FireTruckOutlined />,
    label: 'Non-ABD PTL Shipments',
    id: 'menu-ptl-shipment',
    displayInSidebar: true,
    group: 'PTL_FREIGHT',
    zone: 'PTL_FREIGHT',
    vertical: 'PTL',
    menuItems: [
      {
        pathname: '/b2b-orders',
        label: 'All Non-ABD Shipments',
        component: <ListOrder2 shipmentType='B2B' abdMode='nonabd' />,
      },
      {
        pathname: '/nonabd-missed-repeat',
        label: 'Missed & Repeat Deliveries',
        component: <MissedRepeat abd={false} />,
      },
      {
        pathname: '/nonabd-edd-breaches',
        label: 'EDD Breaches',
        component: <PtlEddBreaches />,
      },
      {
        pathname: '/nonabd-needs-action',
        label: 'Needs Action',
        component: <NeedsAction abd={false} />,
      },
      {
        pathname: '/nonabd-reports',
        label: 'Reports & Analytics',
        component: <ReportsAnalytics abd={false} />,
      },
      {
        pathname: '/nonabd-bulk-upload',
        label: 'Bulk Upload',
        component: <AppointmentsBulkUpload />,
      },
    ],
  },
  {
    pathname: '/appointments/all',
    roles: ROLE_COMBINATIONS.PTL_ORDERS,
    icon: <EventNoteOutlined />,
    label: 'ABD PTL Shipments',
    id: 'menu-appointment-deliveries',
    displayInSidebar: true,
    group: 'PTL_FREIGHT',
    zone: 'PTL_FREIGHT',
    vertical: 'PTL',
    menuItems: [
      {
        pathname: '/appointments/all',
        label: 'All ABD Shipments',
        component: <AllAppointments />,
      },
      {
        pathname: '/appointments/missed-repeat',
        label: 'Missed & Repeat Deliveries',
        component: <MissedRepeat />,
      },
      {
        pathname: '/appointments/overdue',
        label: 'Overdue Appointments',
        component: <PtlOverdueAppointments />,
      },
      {
        pathname: '/appointments/needs-action',
        label: 'Needs Action',
        component: <NeedsAction />,
      },
      {
        pathname: '/appointments/analytics',
        label: 'Reports & Analytics',
        component: <ReportsAnalytics />,
      },
    ],
  },
  {
    pathname: '/ptl-courier-performance',
    roles: ROLE_COMBINATIONS.PTL_ORDERS,
    icon: <LeaderboardOutlined />,
    label: 'PTL Courier Performance',
    displayInSidebar: true,
    group: 'PTL_FREIGHT',
    zone: 'PTL_FREIGHT',
    vertical: 'PTL',
    menuItems: [
      {pathname: '/ptl-courier-performance', label: 'Non-ABD Courier Performance', component: <Dashboard />},
      {pathname: '/ptl-courier-performance/non-abd-comparison', label: 'Non-ABD Courier Comparison', component: <Dashboard />},
      {pathname: '/ptl-courier-performance/abd', label: 'ABD Courier Performance', component: <Dashboard />},
      {pathname: '/ptl-courier-performance/abd-comparison', label: 'ABD Courier Comparison', component: <Dashboard />},
    ],
  },
  {
    pathname: '/rate-calculator-ptl',
    roles: ROLE_COMBINATIONS.TOOLS_ACCESS,
    icon: <CalculateOutlined />,
    label: 'PTL Rate Calculator',
    component: <ShipmentRateCalculatorPTL />,
    displayInSidebar: true,
    group: 'PTL_FREIGHT',
    zone: 'PTL_FREIGHT',
    vertical: 'PTL',
  },
  {
    pathname: '/zone-mapping-ptl',
    roles: ROLE_COMBINATIONS.PTL_ORDERS,
    icon: <DownloadOutlined />,
    label: 'Downloads',
    id: 'menu-ptl-downloads',
    displayInSidebar: true,
    group: 'PTL_FREIGHT',
    zone: 'PTL_FREIGHT',
    vertical: 'PTL',
    menuItems: [
      { pathname: '/zone-mapping-ptl', label: 'Zone Mapping', component: <ZoneMapping freightType='B2B' /> },
      { pathname: '/download-pod-ptl', label: 'Proof of Delivery', component: <BulkDownloadPOD freightType='B2B' /> },
    ],
  },
  {
    pathname: '/merchant-rules-ptl',
    roles: ROLE_COMBINATIONS.PTL_ORDERS,
    icon: <RuleOutlined />,
    label: 'Shipping Rules',
    id: 'menu-ptl-shipping-rules',
    displayInSidebar: true,
    group: 'PTL_FREIGHT',
    zone: 'PTL_FREIGHT',
    vertical: 'PTL',
    enableForConfig: 'allocationVisibleMerchantPanel',
    component: <Rules freightType='B2B' />,
  },

  // ══════════════════════════════════════════════════════════════
  // ZONE: ACCOUNT — shared account & configuration
  // ══════════════════════════════════════════════════════════════
  {
    pathname: '/wallet',
    roles: ROLE_COMBINATIONS.FINANCE_ACCESS,
    icon: <AccountBalanceWalletOutlined />,
    label: 'Wallet & Billing',
    id: 'menu-wallet',
    displayInSidebar: true,
    group: 'ACCOUNT',
    zone: 'ACCOUNT',
    vertical: 'BOTH',
    menuItems: [
      {pathname: '/billing', label: 'COD Remittance', component: <BillingCodRemittance />},
      {pathname: '/wallet-recharges', label: 'Wallet Recharges', component: <BillingWalletRecharges />},
      {pathname: '/passbook', label: 'Passbook', component: <BillingPassbook />},
      {pathname: '/credit', label: 'Credit', component: <Credit />},
      {pathname: '/merchant-invoice', label: 'Invoices', component: <MerchantInvoice />},
    ],
  },
  {
    pathname: '/serviceable-pincodes',
    roles: ROLE_COMBINATIONS.TOOLS_ACCESS,
    icon: <LocationSearchingOutlined />,
    label: 'Serviceability',
    displayInSidebar: true,
    group: 'D2C_FREIGHT',
    zone: 'D2C_FREIGHT',
    vertical: 'D2C',
    menuItems: [
      // {pathname: '/serviceable-pincodes/forward', label: 'Forward Delivery', component: <Serviceability />},
      // {pathname: '/serviceable-pincodes/sdd', label: 'Same-Day Delivery', component: <Serviceability />},
      // {pathname: '/serviceable-pincodes/ndd', label: 'Next-Day Delivery', component: <Serviceability />},
      // {pathname: '/serviceable-pincodes/rvp', label: 'RVP Serviceability', component: <Serviceability />},
      // {pathname: '/serviceable-pincodes/couriers', label: 'By Courier Partner', component: <Serviceability />},
      // {pathname: '/serviceable-pincodes/check', label: 'Check PIN Serviceability', component: <Serviceability />},
      {pathname: '/serviceable-pincodes/coverage', label: 'Coverage', component: <Coverage />},
      {pathname: '/serviceable-pincodes/check-serviceability', label: 'Check Serviceability', component: <CheckServiceability />},
      {pathname: '/serviceable-pincodes/download', label: 'Download Serviceability', component: <DownloadServiceability />},
    ],
  },
  {
    pathname: '/dashboard/courier',
    roles: ROLE_COMBINATIONS.B2C_ORDERS,
    icon: <LeaderboardOutlined />,
    label: 'D2C Courier Performance',
    displayInSidebar: true,
    group: 'D2C_FREIGHT',
    zone: 'D2C_FREIGHT',
    vertical: 'D2C',
    menuItems: [
      {pathname: '/dashboard/courier', label: 'Surface Performance', component: <Dashboard />},
      {pathname: '/dashboard/courier/air', label: 'Air Performance', component: <Dashboard />},
      {pathname: '/dashboard/courier/sdd', label: 'SDD Performance', component: <Dashboard />},
      {pathname: '/dashboard/courier/sc-ndd', label: 'Same-City NDD', component: <Dashboard />},
      {pathname: '/dashboard/courier/ic-ndd', label: 'Inter-City NDD', component: <Dashboard />},
      {pathname: '/dashboard/courier-comparison', label: 'Courier Comparison', component: <Dashboard />},
    ],
  },
  {
    pathname: '/reports',
    roles: ROLE_COMBINATIONS.REPORTS_ACCESS,
    icon: <SummarizeOutlined />,
    label: 'Reports & Exports',
    component: <Reports />,
    displayInSidebar: true,
    group: 'ACCOUNT',
    zone: 'ACCOUNT',
    vertical: 'BOTH',
  },
  {
    pathname: '/download-mis-from-awb',
    roles: ROLE_COMBINATIONS.TOOLS_ACCESS,
    icon: <DownloadOutlined />,
    label: 'Downloads',
    displayInSidebar: true,
    group: 'ACCOUNT',
    zone: 'ACCOUNT',
    vertical: 'BOTH',
    menuItems: [
      { pathname: '/download-mis-from-awb', label: 'MIS from AWB', component: <AWBbasedMIS /> },
      { pathname: '/sorter-image-download', label: 'Sorter Images', component: <SorterImage /> },
    ],
  },
  // Help & Support: EMS V2 or the old Freshdesk-backed page, per REACT_APP_EMS_V2_ENABLED (see
  // emsV2Visibility.js). With EMS V2 off there is no /support-v2 route at all.
  ...(EMS_V2_ENABLED
    ? [
        {
          // The old Freshdesk-backed Help & Support, retired by EMS V2: bookmarks and old links
          // land on the new page.
          pathname: '/escalation_management',
          roles: ROLE_COMBINATIONS.TOOLS_ACCESS,
          component: <Navigate to='/support-v2' replace />,
        },
        {
          // Escalation Desk V2, on the in-house ticket backend (proship_mongo's escalation module).
          pathname: '/support-v2',
          roles: ROLE_COMBINATIONS.TOOLS_ACCESS,
          icon: <SupportAgentOutlined />,
          label: 'Help & Support',
          component: <EscalationManagementV2 />,
          displayInSidebar: true,
          group: 'ACCOUNT',
          zone: 'ACCOUNT',
          vertical: 'BOTH',
        },
      ]
    : [
        {
          pathname: '/escalation_management',
          roles: ROLE_COMBINATIONS.TOOLS_ACCESS,
          icon: <SupportAgentOutlined />,
          label: 'Help & Support',
          component: <EscalationManagement />,
          displayInSidebar: true,
          group: 'ACCOUNT',
          zone: 'ACCOUNT',
          vertical: 'BOTH',
        },
      ]),
  {
    // A heading rather than a link now that it has children — a parent with
    // `menuItems` never renders as a link — so the landing page it used to be
    // is listed as the first child and /setting still resolves to it.
    pathname: '/setting',
    roles: ROLE_COMBINATIONS.SETTINGS_ACCESS,
    icon: <SettingsOutlined />,
    label: 'Settings',
    displayInSidebar: true,
    group: 'ACCOUNT',
    zone: 'ACCOUNT',
    vertical: 'BOTH',
    menuItems: [
      {pathname: '/setting', label: 'Settings & Configuration', component: <Setting />},
      // A Weight Freeze sub-module, reached from here instead: the SKUs,
      // sub-categories and packing material it maintains are account master
      // data a merchant sets up once, not a step in raising a freeze. Same page
      // and same URL — only the label and the row leading to it changed.
      {pathname: '/weight-freeze-v2/product-master', label: 'Package master', component: <WeightFreezeV2 />, enableForConfig: WEIGHT_V2_CONFIG},
    ],
  },
  {
    pathname: '/profile',
    icon: <BadgeOutlined />,
    label: 'Profile & KYC',
    component: <Profile />,
    displayInSidebar: true,
    group: 'ACCOUNT',
    zone: 'ACCOUNT',
    vertical: 'BOTH',
  },
  // ── Non-sidebar routes (unchanged) ──
  {
    pathname: '/claims/:claimId',
    roles: ROLE_COMBINATIONS.CLAIMS_ACCESS,
    label: 'Claim Detail',
    id: 'menu-claim-detail',
    component: <ClaimDetail />,
    displayInSidebar: false,
  },
  /*
    /courier-priority is now registered by the directPlan route table itself (SETTINGS_PATHS),
    so the alias that used to stand in for it here would be a duplicate pathname — two entries,
    different roles, first match wins. Removed rather than left to rot.
  */
  {
    pathname: '/custom-rule',
    roles: ROLE_COMBINATIONS.TOOLS_ACCESS,
    component: <CustomRule />,
  },
  {
    pathname: '/dashboard',
    roles: ROLE_COMBINATIONS.TOOLS_ACCESS,
    component: <Dashboard />,
  },
  {
    pathname: '/orders/create-reverse/:id',
    roles: ROLE_COMBINATIONS.B2C_ORDERS,
    component: <ReverseOrder />,
  },
  {
    pathname: '/clone-order/:awbNumber',
    roles: ROLE_COMBINATIONS.B2C_ORDERS,
    component: <CloneOrderStepper />,
  },
  {
    pathname: '/ptl-pickup-requests/:id',
    roles: ROLE_COMBINATIONS.PTL_ORDERS,
    component: <PickupRequestDetails />,
  },
  {
    pathname: '/order-detail',
    roles: ROLE_COMBINATIONS.ALL_ORDERS,
    component: <OrderDetail />,
  },
  {
    pathname: '/tracking-list',
    roles: ROLE_COMBINATIONS.ALL_ORDERS,
    component: <ListTracking />,
  },
  {
    pathname: '/tracking-detail',
    roles: ROLE_COMBINATIONS.ALL_ORDERS,
    component: <TrackingDetail />,
  },
  {
    pathname: '/merchant-step2',
    roles: ROLE_COMBINATIONS.SETTINGS_ACCESS,
    component: <PickupLocationTab />,
  },
  {
    pathname: '/merchant-step3',
    roles: ROLE_COMBINATIONS.SETTINGS_ACCESS,
    component: <MerchantUsers />,
  },
  {
    pathname: '/merchant-preview',
    roles: ROLE_COMBINATIONS.SETTINGS_ACCESS,
    component: <MerchantPreview />,
  },
  {
    pathname: '/create-order-step2',
    roles: ROLE_COMBINATIONS.B2C_ORDERS,
    component: <CreateOrderStep2 />,
  },
  {
    pathname: '/preview-order',
    roles: ROLE_COMBINATIONS.B2C_ORDERS,
    component: <PreviewOrder />,
  },
  {
    pathname: '/setting/package',
    roles: ROLE_COMBINATIONS.SETTINGS_ACCESS,
    component: <Package />,
  },
  {
    pathname: '/tracking-config',
    roles: ROLE_COMBINATIONS.SETTINGS_ACCESS,
    component: <TrackingConfig />,
  },
  ...(EMS_V2_ENABLED
    ? [
        {
          // An old Freshdesk ticket link: its ticket id means nothing to V2, so open the ticket list.
          pathname: '/escalation_management/view',
          roles: ROLE_COMBINATIONS.TOOLS_ACCESS,
          component: <Navigate to='/support-v2' replace />,
        },
        {
          pathname: '/support-v2/view',
          roles: ROLE_COMBINATIONS.TOOLS_ACCESS,
          component: <EscalationV2ViewTicket />,
        },
      ]
    : [
        {
          pathname: '/escalation_management/view',
          roles: ROLE_COMBINATIONS.TOOLS_ACCESS,
          component: <View />,
        },
      ]),
  {
    pathname: '/weight-discrepancy-bulk-action',
    roles: ROLE_COMBINATIONS.WEIGHT_DISCREPANCY,
    component: <WeightDiscrepancyUpload />,
  },
  {
    // Package master's route a second time, under the role that used to reach
    // it. PrivateRoute gates on the top-level entry only, so the copy under
    // Settings inherits SETTINGS; without this one a merchant holding only
    // WEIGHT_DESC would lose a page they have today, and the SoP's "go to the
    // catalogue" and "go to packing material" links would land them on
    // UnAuthorized. Same shape /dashboard already uses above — one path, two
    // entries, so either role can resolve it.
    pathname: '/weight-freeze-v2/product-master',
    roles: ROLE_COMBINATIONS.WEIGHT_DISCREPANCY,
    component: <WeightFreezeV2 />,
    enableForConfig: WEIGHT_V2_CONFIG,
  },
  {
    pathname: '/delivery-location',
    component: <MerchantDeliveryLocations />,
  },
  {
    pathname: '/notification',
    component: <Notification />,
  },
  {
    pathname: '/allupdates',
    component: <PushNotificationList />,
    icon: <NotificationsActiveOutlined />,
    label: 'Operations Alert',
    displayInSidebar: true,
    group: 'SUPPORT',
    zone: 'GENERAL',
    vertical: 'BOTH',
  },
  {
    pathname: '/profile/verfication/:step',
    component: <Kyc />,
  },
  {
    pathname: '/change-password',
    component: <ChangePassword />,
  },
  {
    pathname: '/whats-new',
    component: <ReleaseNotes />,
    icon: <CampaignOutlined />,
    label: 'Release Notes',
    displayInSidebar: true,
    group: 'SUPPORT',
    zone: 'GENERAL',
    vertical: 'BOTH',
  },
  {
    pathname: '/whats-new/:id',
    component: <ReleaseNoteDetail />,
  },
  {
    pathname: '/rate-card',
    roles: ROLE_COMBINATIONS.B2C_ORDERS,
    icon: <RequestQuoteOutlined />,
    label: 'Rate Card',
    id: 'menu-d2c-rate-card',
    displayInSidebar: true,
    group: 'D2C_FREIGHT',
    zone: 'D2C_FREIGHT',
    vertical: 'D2C',
    enableForConfig: 'rateCardVisibleMerchantPanel',
    component: <RateCard />,
  },
  {
    pathname: '/view-webhook',
    component: <ViewWebHook />,
  },
  {
    pathname: '/configue-webhook',
    component: <ConfiguWebhook />,
  },
  {
    pathname: '/cod-on-hold-config',
    component: <CodOnHoldConfig />,
  },
  {
    pathname: '/email-config',
    component: <EmailConfig />,
  },
  {
    pathname: '/communication-config',
    component: <ConfigMain />,
  },
  {
    pathname: '/notification-config',
    component: <NotificationConfig />,
  },
  {
    pathname: '/pickup-drop-mapping',
    component: <ShopifyEddLocation />,
  },
  {
    pathname: '/privacy-policy',
    component: <PrivacyPolicy />,
  },
  {
    pathname: '/refund_cancellation-policy',
    component: <RefundPolicy />,
  },

  /* {
    pathname: '/month-on-month',
    roles: ROLE_COMBINATIONS.DASHBOARD_ACCESS,
    component: <MonthOnMonthAnalysis />,
  }, */

  // ══════════════════════════════════════════════════════════════
  // ZONE: DIRECT_PLAN — ProShip Direct, the merchant-activated plan
  // ══════════════════════════════════════════════════════════════
  ...directPlanRoutes,
]

export function getSidebarItems() {
  return routesConfig.filter((route) => route.displayInSidebar)
}
